module.exports = __webpack_public_path__ + "static/media/related-cases1.fe5d0b63.jpg";